module.exports = __webpack_public_path__ + "img/page4-1.18c7fb2a.png";